//export const SHORT: string = ".Short";

export const ACTION_SUFFIX: string = ".Action";

export const FLAG_SUFFIX: string = ".Flag";

export const FORM_SUFFIX: string = ".Form";

export const LABEL_SUFFIX: string = ".Label";

export const MESSAGE_SUFFIX: string = ".Message";

export const PATIENT_SUMMARY_SUFFIX: string = ".PatientSummary";

export const TITLE_SUFFIX: string = ".Title";

export const WORKLIST_COLUMN_SUFFIX: string = ".WorklistColumn";

export const WORKLIST_SUFFIX: string = ".Worklist";

export const MANAGEMENT_REP_SUFFIX: string = ".MgmtParameter";

export const KENDO_PREFIX: string = "kendo.";
